import React from 'react'
import { useQuery } from '@apollo/client'
import Loading from 'components/Loading'
import PageError from 'components/pages/PageError'
import {
  trucksListQuery,
  trucksListQueryVariables
} from 'components/TrucksList/types/trucksListQuery'
import TruckCard from 'components/TruckCard'
import pathFromUrl from 'utils/pathFromUrl'
import ButtonLink from 'components/ui/ButtonLink'

import QUERY from './query'

type Props = {
  marketId: number
}

const TrucksList = ({ marketId }: Props) => {
  const { data, error, previousData } = useQuery<
    trucksListQuery,
    trucksListQueryVariables
  >(QUERY, {
    fetchPolicy: 'cache-and-network',
    variables: {
      marketId,
      trucksLimit: 6
    },
    skip: !marketId
  })

  const loading =
    (!data || !data.market?.popularTrucks) && !previousData && !error
  if (loading)
    return (
      <div className="w-full h-72 flex justify-center items-center">
        <Loading />
      </div>
    )
  if (error) return <PageError>{error.message}</PageError>

  const {
    market: {
      name: marketName,
      customerTrucksListPath,
      popularTrucks: { records: trucks }
    }
  } = data || previousData!

  if (trucks.length === 0) return null

  return (
    <div>
      <div className="md:-mx-4 flex flex-wrap box-border">
        {trucks.map((truck) => (
          <div key={truck.id} className="md:w-1/2 w-full">
            <TruckCard
              foodTypes={truck.menus[0]?.foodTypes}
              image={truck.foodImage!.medium}
              name={truck.name}
              rating={truck.ratingInfo}
              truckPath={pathFromUrl(truck.scheduleUrl)}
            />
          </div>
        ))}
      </div>

      <div className="flex justify-center mt-2">
        <ButtonLink
          color="primary"
          href={customerTrucksListPath}
          variant="outline"
        >
          {`View all food trucks in ${marketName}`}
        </ButtonLink>
      </div>
    </div>
  )
}

export default TrucksList
